import ImageLoader from "./image-loader";
export default ImageLoader;
